import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79e5b85e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bridge-container" }
const _hoisted_2 = {
  key: 0,
  class: "bridge-content"
}


const __default__ = {
  name:'CBridge'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    count: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_svg_icon, {
        class: "svgi",
        icon: "bell",
        style: {"width":"24px"}
      })
    ]),
    (props.count>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.count), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})